import { useState } from 'react'
import { Link } from '@tanstack/react-router'
import Nav from '../nav'
import { Burger, Close } from '../svg'
import { ArrowLeft } from '../svg/arrowLeft'

export default function Header() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <header className="relative px-5 py-3 flex items-center justify-between gap-3 md:gap-6 z-50 bg-white shadow-md">
      <div className="flex items-center gap-3 md:gap-6">
        <Link to="/" className="relative flex-shrink-0">
          <img
            src="/img/logo.svg"
            alt={WHOLESALERNAME}
            className="h-[56px] w-auto object-contain"
          />
        </Link>

        <a
          href="https://localityenergy.com.au/"
          className="border-1 hover:border-secondary hover:text-primary transition-all ease-in-out duration-300 border-primary box-border flex items-center gap-1 !no-underline py-1 px-3 rounded-full text-ellipsis whitespace-nowrap overflow-hidden text-[13px]"
        >
          <div className="flex-shrink-0">
            <ArrowLeft size={18} />
          </div>
          <p className="truncate block">Return to the main LPE site</p>
        </a>
      </div>

      {/* Desktop Nav */}
      <nav className="hidden md:flex items-center justify-center gap-4">
        <Nav />
      </nav>

      {/* Mobile Burger */}
      <div className="md:hidden flex items-center">
        <button onClick={() => setIsOpen(!isOpen)}>
          {isOpen ? <Close size={35} /> : <Burger size={35} />}
        </button>
      </div>

      {/* Mobile Dropdown */}
      <div
        className={`
          absolute top-full left-0 w-full bg-white shadow-md overflow-hidden
          md:hidden transition-max-height duration-300 ease-in-out
          ${isOpen ? 'max-h-60' : 'max-h-0'}
        `}
      >
        <nav className="flex flex-col items-center gap-6 py-6">
          <Nav onClick={() => setIsOpen(!isOpen)} />
        </nav>
      </div>
    </header>
  )
}
